import LTR from "@brand-icons/ploom/ui-warning/ui-warning-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiWarningIcon = iconFactory("UiWarningIcon", LTR);
